import {useEffect, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import './../ContentScormModal.css'
import {homeSaveContentStatistics} from '../../modules/auth/core/_requests'
import {useAuth} from '../../modules/auth'
import {contentViewType} from '../../../IOTFYEDUTypeList'

function ContentScromModal({item = []}: any) {
  const {currentUser} = useAuth()
  const [isFullScreen, setIsFullScreen] = useState(false)

  function handleFullscreenChange() {
    setIsFullScreen(!!document.fullscreenElement)
  }

  // 👇 Açılışta otomatik tam ekran olarak ayarlıyoruz.
  useEffect(() => {
    const modalElement: any = document.getElementById('contentScrom_modal')
    // Modal açıldığında tam ekran moda geç
    modalElement.addEventListener('shown.bs.modal', () => {
      enterFullscreen()
    })

    return () => {
      modalElement.removeEventListener('shown.bs.modal', () => {
        exitFullscreen()
      })
    }
  }, [])
  //

  // 👇 Modal İlk Açılış ve Kapanış Kontrolü
  useEffect(() => {
    if (item && item.id) {
      const modalElement: any = document.getElementById('contentScrom_modal')
      modalElement.addEventListener('shown.bs.modal', () => {
        //console.log('View Açılış', item.id)
        sendContentStatistics(getViewId('View'))
      })

      modalElement.addEventListener('hidden.bs.modal', () => {
        //console.log('Close Kapanış', item.id)
        sendContentStatistics(getViewId('Close'))
      })
    }
  }, [item])

  // 👇 Bulunan Sayfa dışında bir yere gidildiğinde modalı kapatıyoruz.
  useEffect(() => {
    if (item && item.id) {
      const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
          // Tarayıcı penceresi pasif durumdaysa (tarayıcı arka planda)
          // console.log('Close Pasif')
          sendContentStatistics(getViewId('Close'))
        } else {
          // Tarayıcı penceresi tekrar aktif olduğunda
          // console.log('View Aktif')
          sendContentStatistics(getViewId('View'))
        }
      }
      // Tarayıcı penceresinin görünürlük durumunu dinle
      document.addEventListener('visibilitychange', handleVisibilityChange)

      return () => {
        // Listener'ı temizle
        document.removeEventListener('visibilitychange', handleVisibilityChange)
      }
    }
  }, [item])
  //

  // 👇 Tam Ekran İşlemleri
  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange)
    }
  }, [])

  function enterFullscreen() {
    const col8Element = document.querySelector(`.lesson-content-modal`) as HTMLElement

    if (col8Element.requestFullscreen) {
      col8Element.requestFullscreen()
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    }
  }

  if (item.length > 0) {
    return null
  }

  // 👇 İstatistik İçin Veri Gönder
  const sendContentStatistics = async (viewType: number) => {
    if (currentUser && item) {
      try {
        const {data} = await homeSaveContentStatistics(
          currentUser?.id,
          item?.id,
          new Date(),
          viewType
        )
      } catch (error) {
        console.error(error)
      }
    }
  }

  // 👇 View Type Dön
  function getViewId(type: string) {
    const viewType = contentViewType.find((item) => item.name === type)
    return viewType ? viewType.id : 0
  }

  return (
    <div className='modal fade' tabIndex={-1} id='contentScrom_modal'>
      <div className='modal-dialog modal-fullscreen p-5'>
        <div className='modal-content shadow-none'>
          <div className='modal-header'>
            <h3 className='modal-title'>{item?.contentTitle}</h3>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-2qx' />
            </div>
          </div>
          <div className='modal-body '>
            <div className={`card card-flush h-100 lesson-content-modal`}>
              <iframe
                src={`${process.env.REACT_APP_API_URL?.slice(0, -4)}${item?.file?.filePath}`}
                height='100%'
                width='100%'
                allowFullScreen={isFullScreen}
              />
              <button
                className='d-flex align-items-center justify-content-center btn btn-icon btn-light btn-sm btn-active-color-primary'
                onClick={() => (isFullScreen ? exitFullscreen() : enterFullscreen())}
                style={{position: 'absolute', top: 5, left: 5}}
              >
                {isFullScreen ? (
                  <i className='bi bi-arrows-angle-contract fs-3 text-gray-400' />
                ) : (
                  <i className='bi bi-arrows-fullscreen fs-3 text-gray-400' />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentScromModal
